import { jsx } from "react/jsx-runtime";
import { ModuleSettingsStore } from "../../../utils/contentstack/moduleSettingsStore.js";
import { useMemo } from "react";
import { DrawerV2, Notification } from "@nxt-costco-com/forge-components";
import { Alert } from "@nxt-costco-com/forge-icons";
import { useConsentManager } from "../../../hooks/useConsentManager/index.js";
import { TITLE_TEXT_KEY, CLOSE_BUTTON_ARIA_LABEL_TEXT_KEY, BACK_BUTTON_ARIA_LABEL_TEXT_KEY, ERROR_MESSAGE_TEXT_KEY } from "./constants.js";
const ConsentManagementErrorDrawer = ({ moduleSettings }) => {
  const {
    state: { isErrorDrawerOpen },
    closeErrorDrawer
  } = useConsentManager();
  const moduleSettingsStore = useMemo(
    () => new ModuleSettingsStore({
      composable_window: moduleSettings.composable_window,
      key_value: moduleSettings.key_value
    }),
    [moduleSettings]
  );
  const title = moduleSettingsStore.getComposableWindowItem(TITLE_TEXT_KEY);
  const closeButtonAriaLabel = moduleSettingsStore.getComposableWindowItem(
    CLOSE_BUTTON_ARIA_LABEL_TEXT_KEY
  );
  const backButtonAriaLabel = moduleSettingsStore.getComposableWindowItem(
    BACK_BUTTON_ARIA_LABEL_TEXT_KEY
  );
  const errorMessage = moduleSettingsStore.getComposableWindowItem(
    ERROR_MESSAGE_TEXT_KEY
  );
  return /* @__PURE__ */ jsx(
    DrawerV2,
    {
      anchor: "right",
      open: isErrorDrawerOpen,
      headerProps: {
        title,
        backButtonAriaLabel,
        closeButtonAriaLabel,
        onClose: () => {
          closeErrorDrawer();
        }
      },
      "aria-label": title,
      bodySx: { padding: 2 },
      scrollArea: "body",
      children: /* @__PURE__ */ jsx(
        Notification,
        {
          message: errorMessage,
          severity: "critical",
          icon: /* @__PURE__ */ jsx(Alert, {})
        }
      )
    }
  );
};
export {
  ConsentManagementErrorDrawer
};
